import { useState as m, useRef as l, useLayoutEffect as d, useEffect as k, useCallback as C } from "react";
import { useCommittedCallback as L } from "../../useCommittedCallback/index.js";
import { hasScope as p, assertScope as b } from "../system/assertions.js";
import { GLOBAL_SCOPE as S } from "../system/constants.js";
import "../key/constants.js";
function P(o) {
  const [c, r] = m([]), s = l(S), f = c.findLast(({ scope: e }) => p(o, e))?.scope ?? S;
  d(() => {
    s.current = f;
  }, [f]), k(() => {
    c.some(({ scope: e }) => !p(o, e)) && r((e) => e.filter(({ scope: t }) => p(o, t)));
  }, [c, o]);
  const u = C(
    (e) => {
      b(o, e, "InputSystemProvider.registerScope");
      const t = Symbol(e);
      return r((i) => [...i, { id: t, scope: e }]), () => {
        r((i) => i.filter((n) => n.id !== t));
      };
    },
    [o]
  ), a = L(u);
  return { effectiveScope: f, effectiveScopeRef: s, registerScope: a };
}
export {
  P as useScopeStack
};
